export const OUTPUTFORMAT = [
  {
    name: "Default",
  },
  {
    name: "Subtotal",
  },
];
